import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "@/modules/collector_v2/lib/api";

export function useApiPolling(path, intervalMs = 5000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const lifecycle = useRef(null);
  const fetchData = useCallback(async (silent = false) => {
    const scope = lifecycle.current;
    if (!scope || scope.path !== path || scope.pending) return;
    const controller = new AbortController();
    scope.pending = controller;
    if (!silent) setLoading(true);
    try {
      const response = await axios.get(`${API}${path}`, { signal: controller.signal, timeout: 15000 });
      if (lifecycle.current !== scope) return;
      setData(response.data); setLastUpdatedAt(new Date()); setError("");
    } catch (err) {
      if (lifecycle.current === scope && !controller.signal.aborted) {
        const detail = err.response?.data?.detail;
        setError(typeof detail === "string" ? detail : err.message || "Error consultando API");
      }
    } finally {
      if (lifecycle.current === scope) { scope.pending = null; setLoading(false); }
    }
  }, [path]);
  useEffect(() => {
    const scope = { path, pending: null };
    lifecycle.current = scope;
    setData(null); setLastUpdatedAt(null); setError("");
    if (!path) { setLoading(false); return () => { lifecycle.current = null; }; }
    fetchData(false);
    const id = intervalMs > 0 ? setInterval(() => fetchData(true), intervalMs) : null;
    return () => { clearInterval(id); lifecycle.current = null; scope.pending?.abort(); };
  }, [fetchData, path, intervalMs]);
  return { data, loading, error, refetch: () => fetchData(false), lastUpdatedAt };
}
